import type { ApiResponse } from '@Types';
import { API } from '@Providers';

export default async function (savedReportId: string) {
  const endpoint = `/api/shelter/saved-reports/${savedReportId}/delete`;

  return API({ endpoint, method: 'post' }) as Promise<ApiResponse<{ _id: string }>>;
}
